import { FC, useMemo } from "react";
import useQueryState from "shared/hooks/useQueryState";
import { CampusTypesBarWrapper, HoverItemTextCampusTypesBar } from "./styles";
import { BREAKPOINTS, Dropdown, DropdownListItem, FInter, useBreakpoint } from "@brg/ui";
import { GtTypesFr } from "shared/pages/teams/const/GtTypes";
import { DropdownText } from "shared/navbars/components/contextTabsItems";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { HoverItemText, HoverItemWithSvg } from "shared/components/projectsSearchBar/style";
import { AppTester } from "supporting";
import { getCurrentAppName } from "supporting";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { mainType } from "./const";
import { useRouteMatch } from "react-router-dom";
import { isMainFrDomain } from "shared/pages/CampusExpert/const";
export const CampusTypesBar: FC = () => {
    const theme = useTheme();
    const [{ campusType =  mainType.value }, setQueryParams] = useQueryState();
    const { t, i18n: {language} } = useTranslation();
    const isDesignContext = (getCurrentAppName() !== 'competition' && getCurrentAppName() !== 'deziiign' && !AppTester.isGeoDafes() && !AppTester.isNewDafesSegment());
    const isSuperPuper = AppTester.isSuperPuper();
    const isMobile = useBreakpoint(BREAKPOINTS.MOBILE_MAX);
    const isFrTagExpertPage = !!useRouteMatch('/tag-expert');

    const normilezedCampusName = useMemo(() => {
        if (campusType === mainType.value) {
            if (language === 'fr') return 'tous';
            return mainType.value;
        }
        return campusType.split('-')?.[1];
    }, [campusType]);

    const onItemClick = (value: string) => {
        if (value === mainType.value) {
            setQueryParams({ campusType: isFrTagExpertPage ? value :undefined });
            return;
        }
        setQueryParams({ campusType: value });
    }

    const list = useMemo(() => {
        return [mainType, ...GtTypesFr].map((item) => {

            if (language === 'fr' && item.value === 'main') {
                return (
                    <DropdownListItem key={item.value} onClick={() => onItemClick(item.value)}>
                        <DropdownText>{'tous'}</DropdownText>
                        <ApprovedIcon fill={theme.tags.textColor} display={campusType === item.value} />
                    </DropdownListItem>
                )
            }
            return (
                <DropdownListItem key={item.value} onClick={() => onItemClick(item.value)}>
                    <DropdownText>{item.label?.split('-')?.[1] || item.label}</DropdownText>
                    <ApprovedIcon fill={theme.tags.textColor} display={campusType === item.value} />
                </DropdownListItem>
            )
        })
    }, [language, campusType])

    if (!isMainFrDomain()) {
        return null;
    }

    return <CampusTypesBarWrapper>
        <Dropdown
            dark={false}
            // {...(isDropdownDarkUi
            //     ? { dropdownPopupBg: darkPanelContentBg, dropdownContentBg: darkPanelContentBg }
            //     : {})}
            offsetArrowX={38}
            // offsetX={-60}
            hideArrow
            orientation={isMobile ? 'left' : 'right'}
            maxWidth={220}
            maxHeight={240}
            target={
                <HoverItemWithSvg color={theme.sortByColorSort} gx={8}>
                    <HoverItemTextCampusTypesBar>
                        <span className={'item-prefix'}>{'campus'}</span>
                        <span className={'item-value'}>{normilezedCampusName}</span>
                    </HoverItemTextCampusTypesBar>
                    <FInter.SmallText style={{ alignItems: 'center', display: 'flex' }}>
                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                                fill={theme.tags.textColor} />
                        </svg>
                    </FInter.SmallText>
                </HoverItemWithSvg>
            }
        >
            {list}
        </Dropdown>
    </CampusTypesBarWrapper>
}import { FC, useMemo } from "react";
import useQueryState from "shared/hooks/useQueryState";
import { CampusTypesBarWrapper, HoverItemTextCampusTypesBar } from "./styles";
import { BREAKPOINTS, Dropdown, DropdownListItem, FInter, useBreakpoint } from "@brg/ui";
import { GtTypesFr } from "shared/pages/teams/const/GtTypes";
import { DropdownText } from "shared/navbars/components/contextTabsItems";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { HoverItemText, HoverItemWithSvg } from "shared/components/projectsSearchBar/style";
import { AppTester } from "supporting";
import { getCurrentAppName } from "supporting";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import { mainType } from "./const";
import { useRouteMatch } from "react-router-dom";
import { isMainFrDomain } from "shared/pages/CampusExpert/const";
export const CampusTypesBar: FC = () => {
    const theme = useTheme();
    const [{ campusType =  mainType.value }, setQueryParams] = useQueryState();
    const { t, i18n: {language} } = useTranslation();
    const isDesignContext = (getCurrentAppName() !== 'competition' && getCurrentAppName() !== 'deziiign' && !AppTester.isGeoDafes() && !AppTester.isNewDafesSegment());
    const isSuperPuper = AppTester.isSuperPuper();
    const isMobile = useBreakpoint(BREAKPOINTS.MOBILE_MAX);
    const isFrTagExpertPage = !!useRouteMatch('/tag-expert');

    const normilezedCampusName = useMemo(() => {
        if (campusType === mainType.value) {
            if (language === 'fr') return 'tous';
            return mainType.value;
        }
        return campusType.split('-')?.[1];
    }, [campusType]);

    const onItemClick = (value: string) => {
        if (value === mainType.value) {
            setQueryParams({ campusType: isFrTagExpertPage ? value :undefined });
            return;
        }
        setQueryParams({ campusType: value });
    }

    const list = useMemo(() => {
        return [mainType, ...GtTypesFr].map((item) => {

            if (language === 'fr' && item.value === 'main') {
                return (
                    <DropdownListItem key={item.value} onClick={() => onItemClick(item.value)}>
                        <DropdownText>{'tous'}</DropdownText>
                        <ApprovedIcon fill={theme.tags.textColor} display={campusType === item.value} />
                    </DropdownListItem>
                )
            }
            return (
                <DropdownListItem key={item.value} onClick={() => onItemClick(item.value)}>
                    <DropdownText>{item.label?.split('-')?.[1] || item.label}</DropdownText>
                    <ApprovedIcon fill={theme.tags.textColor} display={campusType === item.value} />
                </DropdownListItem>
            )
        })
    }, [language, campusType])

    if (!isMainFrDomain()) {
        return null;
    }

    return <CampusTypesBarWrapper>
        <Dropdown
            dark={false}
            // {...(isDropdownDarkUi
            //     ? { dropdownPopupBg: darkPanelContentBg, dropdownContentBg: darkPanelContentBg }
            //     : {})}
            offsetArrowX={38}
            // offsetX={-60}
            hideArrow
            orientation={isMobile ? 'left' : 'right'}
            maxWidth={220}
            maxHeight={240}
            target={
                <HoverItemWithSvg color={theme.sortByColorSort} gx={8}>
                    <HoverItemTextCampusTypesBar>
                        <span className={'item-prefix'}>{'campus'}</span>
                        <span className={'item-value'}>{normilezedCampusName}</span>
                    </HoverItemTextCampusTypesBar>
                    <FInter.SmallText style={{ alignItems: 'center', display: 'flex' }}>
                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                                fill={theme.tags.textColor} />
                        </svg>
                    </FInter.SmallText>
                </HoverItemWithSvg>
            }
        >
            {list}
        </Dropdown>
    </CampusTypesBarWrapper>
}